var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-xl"},[_vm._v("文件闪传")]),_c('hr',{staticClass:"my-4"}),_c('SpaceOpener',[_c('Ingress')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }